import { render } from "./tickets-modal.vue?vue&type=template&id=478e15ee"
import script from "./tickets-modal.vue?vue&type=script&lang=js"
export * from "./tickets-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__